import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moreStudent"]

  hide(event) {
    event.currentTarget.style.display = "none"
  }
}
